export enum DocType {
    toDownload = 21,
    sentToASP = 20,
}